import React, { useState } from 'react'
import ProductLearnMoreAboutSamplingModal from 'containers/QuickShopProductSidebar/components/ProductLearnMoreModal/index.js'

import getHasSampledProductDataSelector from 'modules/product/redux/selectors/get-has-sampled-product-data'
import isSampleVariantSelect from 'modules/product/redux/selectors/is-sample'

import useSelector from 'hooks/use-selector'
import logUtil from 'utils/log'

import './index.css'

const FullSizeDiscountAlert = ({
  productVariant,
  isSample
}) => {
  const [isModalOpen, setModalOpen] = useState(false)

  const productId = productVariant?.product_id

  const hasSampledProductData = useSelector(getHasSampledProductDataSelector(productId))
  const isSampleVariant = useSelector(isSampleVariantSelect) ?? isSample

  logUtil('FullSizeDiscountAlert').debug('debug[show=]', { productVariant, hasSampledProductData, isSampleVariant })

  // if the product has been sampled, don't show the alert or if the variant is not a sample
  if (hasSampledProductData?.hasSampled === true || !isSampleVariant) {
    return null
  }

  return (
    <div>
      <div class='full-size-discount-after-sampling-alert'>
        <div>
          <svg width='20' height='20' viewBox='0 0 20 20' fill='none' xmlns='http://www.w3.org/2000/svg'>
            <path fillRule='evenodd' clipRule='evenodd' d='M17.5 3.33331H13.2416C12.0813 3.35181 10.9408 3.63694 9.90829 4.16665L9.39163 4.42498C8.57149 4.82167 7.66914 5.01871 6.75829 4.99998H2.49996C2.03972 4.99998 1.66663 5.37308 1.66663 5.83331V15.8333C1.66663 16.2935 2.03972 16.6666 2.49996 16.6666H6.75829C7.91532 16.6611 9.05566 16.3903 10.0916 15.875L10.6083 15.6166C11.4249 15.2055 12.3274 14.9942 13.2416 15H17.5C17.9602 15 18.3333 14.6269 18.3333 14.1666V4.16665C18.3333 3.70641 17.9602 3.33331 17.5 3.33331ZM16.6666 10.8333C15.2859 10.8333 14.1666 11.9526 14.1666 13.3333H13.2416C12.0847 13.3398 10.9446 13.6106 9.9083 14.125L9.39164 14.3833C8.57366 14.7906 7.67206 15.0017 6.7583 15H5.8333C5.8333 13.6193 4.71401 12.5 3.3333 12.5V9.16668C4.71401 9.16668 5.8333 8.04739 5.8333 6.66668H6.7583C7.9185 6.64729 9.05881 6.36221 10.0916 5.83334L10.6083 5.57501C11.4298 5.18214 12.3312 4.98531 13.2416 5.00001H14.1666C14.1666 6.38072 15.2859 7.50001 16.6666 7.50001V10.8333ZM9.99998 12.5C11.3807 12.5 12.5 11.3807 12.5 10C12.5 8.61931 11.3807 7.50002 9.99998 7.50002C8.61927 7.50002 7.49998 8.61931 7.49998 10C7.49998 11.3807 8.61927 12.5 9.99998 12.5Z' fill='#43965F' />
          </svg>
        </div>
        <span>Get <b>20% off</b> the full size item after you sample it. <button type='button' onClick={() => { setModalOpen(true) }}>Learn more</button></span>
      </div>
      {isModalOpen && <ProductLearnMoreAboutSamplingModal isOpen={isModalOpen} onClose={() => setModalOpen(false)} />}
    </div>
  )
}

export default FullSizeDiscountAlert
